import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CatalogueProductDetailDocumentation" })
export default class CatalogueProductDetailDocumentation extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isDownloading: boolean = false;

    public documentationList: any[] = [];
    public itemSpecifications: any[] = [];
    public productInstructions: any[] = [];
    public files2d: any[] = [];
    public files3d: any[] = [];
    public certifications: any[] = [];
    public bims: any[] = [];
    public dataSheets: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly familyCode: any;
    @Prop() readonly orderCode: any;
    @Prop() readonly culture: any;
    @Prop() readonly productViewPdfUrl: string;
    @Prop() readonly productPdfUrl: any;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;
        let language = this.culture.split('-')[0];

        try {
            const response = (await Axios.post(this.routes.Catalogue_GetProductDetailDocumentationData, { familyCode: this.familyCode, orderCode: this.orderCode })).data;

            this.documentationList = response.documentationList;

            this.itemSpecifications = this.documentationList.filter(x => x.assetType === 'ItemSpecifications' && (x.language == "" || x.language == language));
            this.productInstructions = this.documentationList.filter(x => x.assetType === 'ProductInstructions' && (x.language == "" || x.language == language));
            this.files2d = this.documentationList.filter(x => x.assetType === '2DFile' && (x.language == "" || x.language == language));
            this.files3d = this.documentationList.filter(x => x.assetType === '3DFile' && (x.language == "" || x.language == language));
            this.certifications = this.documentationList.filter(x => x.assetType === 'Certification' || x.assetType === 'CertificationCE' || x.assetType === 'CertificationRED' || x.assetType === 'CertificationUKCA' && (x.language == "" || x.language == language));
            this.bims = this.documentationList.filter(x => x.assetType === 'Bim' || x.assetType === 'BuildingInformationModel' && (x.language == "" || x.language == language));
            this.dataSheets = this.documentationList.filter(x => x.assetType === 'DataSheet' && (x.language == "" || x.language == language));
        } catch (error) {
            this.documentationList = [];
        }

        this.isLoading = false;
    }

    public openPdfUrl() {
        GTagHelper.sendEvent("click", "product_accessory", "technical_sheet");
        window.open(this.productViewPdfUrl, '_blank');
    }

    public setAnalytics() {
        GTagHelper.sendEvent("file_download", "product_documentation")
    }

    public async pdfDownload() {
        if (!this.isDownloading) {
            this.isDownloading = true;

            let response = await Axios.post(this.productPdfUrl, null, { responseType: "blob" });
            if (response) {
                const fileName = response.headers["x-filename"];

                let binaryData = [];
                binaryData.push(response.data);

                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(new Blob(binaryData, { type: response.data.type }));
                link.download = fileName;
                link.click();

                GTagHelper.sendEvent("file_download", "product_documentation");
            }

            this.isDownloading = false;
        }
    }
};